import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { LevelTitle } from '../data/levelTitles';
import './LevelUpAnimation.css';

import { EmojiText } from './common/Picto';
interface LevelUpAnimationProps {
  show: boolean;
  levelInfo: LevelTitle | null;
  onClose: () => void;
}

const LevelUpAnimation: React.FC<LevelUpAnimationProps> = ({ show, levelInfo, onClose }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(onClose, 5000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show || !levelInfo) return null;

  return ReactDOM.createPortal(
    <div className="lu-backdrop" onClick={onClose}>
      <div className="lu-modal" onClick={e => e.stopPropagation()}>
        <div className="lu-badge">NIVEAU {levelInfo.level}</div>
        <div className="lu-icon"><EmojiText text={levelInfo.icon} /></div>
        <div className="lu-name">{levelInfo.name}</div>
        <div className="lu-description">{levelInfo.description}</div>
        <button className="lu-button" onClick={onClose}>
          Continuer l'apprentissage
        </button>
      </div>
    </div>,
    document.body
  );
};

export default LevelUpAnimation;
